/**
 *
 *
 *
 */
export const ROUTE_PATHS = {
    HEALTH: '/health',
    METRICS: '/internal/metrics',
    DESCRIPTION: '/description/:variationId',
} as const;

export type RoutePath = (typeof ROUTE_PATHS)[keyof typeof ROUTE_PATHS];
